import { COMMON_HEADERS_KEYS } from '@utility/checkout-utils';

import type { GetGlobalApiHeadersParams } from '../types/shared';

const X_VOLT_API_VERSION = '1';
export const getGlobalAPIHeaders = ({
  authToken,
  voltApp,
  voltService,
}: GetGlobalApiHeadersParams) =>
  ({
    [COMMON_HEADERS_KEYS.X_VOLT_API_VERSION]: X_VOLT_API_VERSION,
    [COMMON_HEADERS_KEYS.CONTENT_TYPE]: 'application/json',
    [COMMON_HEADERS_KEYS.X_VOLT_APP_AUTHORIZATION]: `Bearer ${authToken}`,
    [COMMON_HEADERS_KEYS.X_VOLT_APP]: voltApp,
    //TODO: Remove this check when PIS is ready to accept X-Volt-Service header
    ...((voltService === 'ais' || voltService === 'mandate') && {
      [COMMON_HEADERS_KEYS.X_VOLT_SERVICE]: voltService,
      [COMMON_HEADERS_KEYS.X_VOLT_INITIATION_CHANNEL]: 'hosted',
    }),
  }) as const;
